import {
  CheckCircleOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { Card, Col, Image, List, Row, Typography } from 'antd';
import React from 'react';
import sampleImage from '../assets/images/sample.png';
import './UserGuide.less';

const { Title, Paragraph, Text } = Typography;

const UserGuide = () => {
  const guideSteps = [
    {
      id: 1,
      title: '配置提取字段',
      icon: <SettingOutlined />,
      color: '#1890ff',
      content: (
        <div>
          <List
            size="small"
            dataSource={[
              { label: '基础信息字段', desc: '填写化验单中的登记号、采集时间等基本信息字段' },
              { label: '检测项目字段', desc: '填写化验单中的项目名称、结果等字段' }
            ]}
            renderItem={(item) => (
              <List.Item style={{ textAlign: 'left', paddingBottom: '8px' }}>
                <div>
                  <Text strong style={{ color: '#1890ff', display: 'block', marginBottom: '2px' }}>
                     {item.label}
                  </Text>
                  <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.5' }}>
                    {item.desc}
                  </Text>
                </div>
              </List.Item>
            )}
            />
            <Paragraph style={{ marginTop: '12px', fontSize: '12px', color: '#8c8c8c' }}>
              应该填绿框标注的字段
            </Paragraph>
            <Image
              src={sampleImage}
              alt="检验单示例"
              width="30%"
              style={{border: '1px solid #f0f0f0' }}
              preview={{
                mask: (
                  <div style={{ color: '#fff', fontSize: '14px' }}>
                    <InfoCircleOutlined /> 查看字段示例
                  </div>
                )
              }}
            />
        </div>
      )
    },
    {
      id: 2,
      title: '上传化验单',
      icon: <FileTextOutlined />,
      color: '#52c41a',
      content: (
        <div style={{ lineHeight: '1.6' }}>
          <div style={{ marginBottom: '12px' }}>
            <Text strong style={{ color: '#52c41a', display: 'block', marginBottom: '4px' }}>
              支持格式
            </Text>
            <Text type="secondary" style={{ fontSize: '13px' }}>
              支持PDF、JPG、JPEG、PNG等格式
            </Text>
          </div>
          
          <div>
            <Text strong style={{ color: '#52c41a', display: 'block', marginBottom: '4px' }}>
              支持数量
            </Text>
            <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.5' }}>
              • 非会员：单次最多20张图片<br />
              • 会员：无数量限制
            </Text>
          </div>
        </div>
      )
    },
    {
      id: 3,
      title: '隐私保护',
      icon: <InfoCircleOutlined />,
      color: '#faad14',
      content: (
        <div style={{ lineHeight: '1.6' }}>
          <div style={{ marginBottom: '12px' }}>
            <Text strong style={{ color: '#faad14', display: 'block', marginBottom: '4px' }}>
              🔒 本地打码
            </Text>
            <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.5' }}>
              上传前自动打码保护敏感信息，防止隐私数据公网传输
            </Text>
          </div>
          
          <div style={{ marginBottom: '12px' }}>
            <Text strong style={{ color: '#faad14', display: 'block', marginBottom: '4px' }}>
              📋 打码范围
            </Text>
            <Text type="secondary" style={{ fontSize: '13px' }}>
              患者姓名、申请医师、检验者等
            </Text>
          </div>
          
          <div>
            <Text strong style={{ color: '#faad14', display: 'block', marginBottom: '4px' }}>
              ⚡ 打码过程
            </Text>
            <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.5' }}>
              本地OCR识别敏感信息，自动添加黑色遮罩
            </Text>
          </div>
        </div>
      )
    },
    {
      id: 4,
      title: '数据提取',
      icon: <CheckCircleOutlined />,
      color: '#f5222d',
      content: (
        <div>
          <Paragraph style={{ marginTop: '12px', marginBottom: 0 }}>
            <Text type="secondary">
              配置完成后，上传您的化验单文件，系统将自动识别并提取关键信息，并生成Excel文件
            </Text>
          </Paragraph>
        </div>
      )
    }
  ];

  return (
    <div className="user-guide">
      <div className="guide-header">
        <Title level={3} style={{ margin: 0, color: '#262626' }}>
          📖 使用指南
        </Title>
      </div>
      
      <Row gutter={[16, 10]} className="guide-cards">
        {guideSteps.map((step, index) => (
          <Col xs={24} sm={12} lg={6} key={step.id}>
            <Card
              className={`guide-card guide-card-${index + 1}`}
              hoverable
              style={{ 
                height: '100%',
                borderColor: step.color,
                borderWidth: '2px'
              }}
              stylesbody={{ 
                padding: '20px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <div className="card-header">
                <div
                  className="step-icon"
                  style={{
                    backgroundColor: step.color,
                    color: '#fff',
                    fontSize: '20px',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '12px'
                  }}
                >
                  {step.icon}
                </div>
                <Title level={5} style={{ 
                  margin: '8px 0 12px 0', 
                  color: '#262626',
                  fontSize: '16px',
                  fontWeight: '600'
                }}>
                  第 {step.id} 步：{step.title}
                </Title>
              </div>
              
              <div className="card-content" style={{ flex: 1 }}>
                {step.content}
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default UserGuide;
